import { useEffect } from 'react'
import { ArtistAlbumBG, ArtistPageRegisterAsArtistImg, ArtistPageRegisterAsBandImg, MainBackgroundVector } from '../../assets'
import { NewsletterCard, NewsletterForm } from '../../components'
import { useStateContext } from '../../context/StateContextAPI'

import "./artist.page.css"
import { Box, Button, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { BackgroundImage} from '../faq/faq.page'
import useGoogleTag from '../../utils/gtag'
import { useTranslation } from 'react-i18next'

const ArtistPageContainer = styled.div`
    width: 100%;
`

const HeaderText = styled.div`
    font-size: 4.5em;
    flex: 1;
    margin: 0;
    font-family: var(--title-font), sans-serif;
    font-weight: var(--font-main-weight);
    line-height: 1em;
    letter-spacing: 1px;
    min-width: 300px;
    @media screen and (max-width: 1000px) {
        font-size: 3.5em;
    }
    @media screen and (max-width: 700px) {
        font-size: 10vw;
    }
`

const ArtistPageHeader = styled.div`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
    padding: 0 var(--global-padding);
    margin: 150px 0 50px 0;
    @media screen and (max-width: 1000px) {
        margin: 80px 0 50px 0;
    }
`

const RegistrationCards = styled.div`
    display: flex;
    flex: 1;
    min-width: 300px;
    aspect-ratio: 2/2.5;
    background: rgba(255, 255, 255, 0.2);
    @media screen and (max-width: 1400px) {
        aspect-ratio: 2/3;
    }
    @media screen and (max-width: 1200px) {
        aspect-ratio: 2/4;
    }
    @media screen and (max-width: 1000px) {
        aspect-ratio: 2/3.5;
    }
    @media screen and (max-width: 680px) {
        aspect-ratio: 2/2.7;
    }
    @media screen and (max-width: 480px) {
        aspect-ratio: 2/3.5;
    }
`

const RegistrationCardsContent = styled.div`
    background: #000;
    background: linear-gradient(180deg, rgba(17, 17, 17, 0.00) 0%, rgba(16, 16, 16, 0.73) 13%, #101010 24.84%);
    height: 50%;
    width: 100%;
    align-self: flex-end;
    box-sizing: border-box;
    padding: 50px;
    @media screen and (max-width: 1000px) {
        padding: 20px;
    }
    @media screen and (max-width: 880px) {
        height: 60%;
    }
`


const ArtistPage = () => {

    // GTAG
    const gtag = process.env.REACT_APP_GOOGLE_TAG || "";
    useGoogleTag(gtag)

    const { setActivePage } = useStateContext();
    const { t } = useTranslation();

    useEffect(() => {
        setActivePage(() => "artists")
        window.scrollTo(0, 0);
    }, [setActivePage])

    type newsletterCard = {
        title: string,
        content: string
    }

    const favouriteBand: newsletterCard = {
        title: t('artist.card1'),
        content: ""
    }
    const allStyleMusic: newsletterCard = {
        title: t('artist.card2'),
        content: ""
    }
    const hiResOfflineMode: newsletterCard = {
        title: t('artist.card3'),
        content: ""
    }
    const importFunction: newsletterCard = {
        title: t('artist.card4'),
        content: ""
    }


    return (
        <ArtistPageContainer>
            <BackgroundImage src={MainBackgroundVector} />
            <ArtistPageHeader>
            <RegistrationCards
                style={{
                    background: `url(${ArtistPageRegisterAsBandImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top center'
                }}
            >
                  <RegistrationCardsContent>
                    <HeaderText>
                        <div>
                            <span className="head-txt-off-white">{t('artist.registerAs')}</span>
                        </div>
                        <div>
                            <span className="head-txt-primary">{t('artist.band')}</span>
                        </div>
                    </HeaderText>
                    <Typography
                        sx={{
                            fontSize: '16px',
                            color: '#ffffff80',
                            fontFamily: 'Poppins, sans-serif',
                            margin: '20px 0',
                            '@media screen and (max-width: 680px)': {
                                fontSize: '14px'
                            }
                        }}
                    >
                    {t('artist.bandDesc')}
                    </Typography>
                    <Button
                            variant="contained"
                            color="primary"
                            type='submit'
                            sx={{
                                backgroundColor: '#ff8303',
                                borderRadius: '8px',
                                padding: '12px 24px',
                                color: '#ffffff',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                '&:hover': {
                                    background: '#ff8303',
                                },
                                '@media screen and (max-width: 680px)': {
                                    width: '100%'
                                }
                            }}
                            onClick={() => window.location.href="https://i-wanna-rokk.com/register"}
                        >
                            {t('artist.registerAsBand')}
                        </Button>
                    </RegistrationCardsContent>      
            </RegistrationCards>

            <RegistrationCards
                style={{
                    background: `url(${ArtistPageRegisterAsArtistImg})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'top center'
                }}
            >
                  <RegistrationCardsContent>
                    <HeaderText>
                        <div>
                            <span className="head-txt-off-white">{t('artist.registerAs')}</span>
                        </div>
                        <div>
                            <span className="head-txt-primary">{t('artist.artist')}</span>
                        </div>
                    </HeaderText>
                    <Typography
                        sx={{
                            fontSize: '16px',
                            color: '#ffffff80',
                            fontFamily: 'Poppins, sans-serif',
                            margin: '20px 0',
                            '@media screen and (max-width: 680px)': {
                                fontSize: '14px'
                            }
                        }}
                    >
                    {t('artist.artistDesc')}
                    </Typography>
                    <Button
                            variant="contained"
                            color="primary"
                            type='submit'
                            sx={{
                                backgroundColor: '#ff8303',
                                borderRadius: '8px',
                                padding: '12px 24px',
                                color: '#ffffff',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                '&:hover': {
                                    background: '#ff8303',
                                },
                                '@media screen and (max-width: 680px)': {
                                    width: '100%'
                                }
                            }}
                            onClick={() => window.location.href="https://i-wanna-rokk.com/register"}
                        >
                            {t('artist.registerAsArtist')}
                        </Button>
                    </RegistrationCardsContent>      
            </RegistrationCards>

            </ArtistPageHeader>

            <ArtistPageHeader>
                <span>
                    {t('artist.benefitsText')}&nbsp;
                    <a href="https://rokk-app.com/ROKK_Artist_Benefits.pdf" download style={{color: "#ff8303"}}>{t('artist.benefitsDownload')}</a>{t('artist.benefitsDownloadSuffix')}
                </span>
            </ArtistPageHeader>
            

            <div className="artists-benefits-cards-wrapper">
                <div className="artists-benefits-card">{t('artist.benefitCard1a')}<div>{t('artist.benefitCard1b')}</div></div>
                <div className="artists-benefits-card">{t('artist.benefitCard2a')}<div>{t('artist.benefitCard2b')}</div></div>
                <div className="artists-benefits-card">{t('artist.benefitCard3a')}<div>{t('artist.benefitCard3b')}</div></div>
            </div>
            <div className="artist-page-main-sec">
                {/* <div className="artist-page-main-sec-img-container">
                    <img src={ArtistAlbumBG} alt="artist_album_main_image" />
                </div> */}
                <div className="artist-page-content">
                    <div className="head-text artist-page-head-text">
                        <div>
                            <span className="head-txt-off-white">{t('artist.mainTitle1')}</span>
                            <br />
                            <span className="head-txt-primary">{t('artist.mainTitle2')}</span>
                        </div>
                        <div>
                            <span className="head-txt-off-white">{t('artist.mainTitle3')}</span>
                            <span className="head-txt-primary">{t('artist.mainTitle4')}</span>
                        </div>
                        <div>
                            <span className="head-txt-primary">{t('artist.mainTitle5')}</span>
                            <span className="head-txt-off-white">{t('artist.mainTitle6')}</span>
                        </div>
                    </div>

                    <div className="head-desc-main">
                        <span>
                            {t('artist.mainDesc1')}
                        </span>
                        <span>
                            {t('artist.mainDesc2')}
                        </span>
                        
                    </div>

                    <div className="auth-section" style={{ justifyContent: 'flex-start' }}>
                        {/* <button className="btn primary-btn" style={{ width: '200px' }} onClick={() => navigate('../register-new-artist')}>Get Started for Free</button> */}
                        <Button
                            variant="contained"
                            sx={{
                                background: '#ff8303',
                                color: '#ffffff',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                borderRadius: '8px',
                                '&:hover': {
                                    background: '#ff8303'
                                }

                            }}
                            // onClick={() => navigate('../register-new-artist')}
                            onClick={() => window.location.href = "https://i-wanna-rokk.com/register"}
                        >
                            {t('artist.getStarted')}
                        </Button>
                    </div>
                </div>

            </div>

            <div className="newsletter-cards-container" style={{ padding: 'var(--global-padding)' }}>
                <NewsletterCard obj={favouriteBand} />
                <NewsletterCard obj={allStyleMusic} />
                <NewsletterCard obj={hiResOfflineMode} />
                <NewsletterCard obj={importFunction} />
            </div>


            <div style={{ padding: 'var(--global-padding)' }}>
                <div className="newsletter-container-pricing-page flex aln-items-cnt">
                    <div className="newsletter-section-header flex flex-dir-col">
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.subscribeTo')}</span>
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.our')}
                            <span className="head-txt-primary">{t('newsletter.rokk')}</span>
                        </span>
                        <span className="head-txt-primary font-sz-small">{t('newsletter.newsletter')}</span>
                    </div>
                    <NewsletterForm />
                </div>
            </div>
        </ArtistPageContainer>
    )
}

export default ArtistPage
